import { ReactComponent as leftSVG} from './chevron-left.svg' 
import { ReactComponent as rightSVG } from './chevron-right.svg' 
import { ReactComponent as downSVG } from './chevron-down.svg' 
import { ReactComponent as upSVG } from './chevron-up.svg' 
import { ReactComponent as minusSVG } from './minus.svg' 
import { ReactComponent as plusSVG } from './plus.svg' 
import { ReactComponent as fbSVG } from './fb.svg' 
import { ReactComponent as twSVG } from './tw.svg' 
import { ReactComponent as insSVG } from './ins.svg' 
import { ReactComponent as linkedinSVG } from './linkedin.svg' 

export {
    leftSVG,
    rightSVG,
    downSVG,
    upSVG,
    minusSVG,
    plusSVG,
    fbSVG,
    twSVG,
    insSVG,
    linkedinSVG
}